import { render, staticRenderFns } from "./SetupTemplate.vue?vue&type=template&id=14ff1e89&scoped=true&"
import script from "./SetupTemplate.vue?vue&type=script&lang=ts&"
export * from "./SetupTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./SetupTemplate.vue?vue&type=style&index=0&id=14ff1e89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ff1e89",
  null
  
)

export default component.exports